import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {HostingService} from "../../../../../../../websites/website/hosting/hosting.service";

@Component({
    selector: 'db-migration-zip-upload',
    templateUrl: './migration-zip-upload.component.html',
    styleUrls: ['./migration-zip-upload.component.scss'],
    standalone: false
})
export class MigrationZipUploadComponent implements OnInit {
  selectedFile: File;
  fileName = null;
  errMessage;
  isMobile = window.innerWidth <= 991;
  @Output() startLoading: EventEmitter<File> = new EventEmitter<File>();
  @Output() back = new EventEmitter<any>();

  constructor(private _hostingService: HostingService) {
  }

  ngOnInit() {
  }

  onChange(event) {
    this.selectedFile = event.target.files[0];
    this.fileName = this.selectedFile.name;
    this.errMessage = '';

    if (!this.selectedFile) {
      return;
    }

    const maxFileSizeGB = 50; // Maximum file size in GB
    if (this.selectedFile.size > maxFileSizeGB * 1024 * 1024 * 1024) {
      this.selectedFile = null;
      this.errMessage = 'The file is too large. Allowed maximum size is 50GB';
      return;
    }

    if (!this.selectedFile.name.toLowerCase().endsWith('.zip')) {
      this.selectedFile = null;
      this.errMessage = 'Invalid extension. Only Zip File is allowed.';
      return;
    }
  }

  uploadFile() {
    this.startLoading.emit(this.selectedFile);
  }

}
